<template>
	<div
		v-bind:class="[
			{
				'builder-element': !onPreview,
				'hide-desktop': node.options.visible_desktop,
				'hide-mobile': node.options.visible_mobile,
			},
			node.class,
		]"
		:id="node.id"
		:data-key="node.key"
		:data-elIcon="node.icon"
		:data-elName="node.name"
		:data-type="node.type"
		@click="onNodeClick(node)"
		:style="getWrapperStyle(node)"
	>
		<NodeAction :node="node" component="element" v-if="!onPreview" />

		<div :style="getStyle(node)">
			<!-- <div
				class="embed-responsive"
				:class="responsiveClass">
				<iframe
					:src="videoUrl"
					frameborder="0"
					allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
					allowfullscreen class="embed-responsive-item">
				</iframe>
			</div> -->
			<YoutubeEmbedLite
				:key="videoId"
				:videoId="videoId"
				:aspect="ratio"
				thumb-quality="hq"
				:params="videoParams"
			/>
		</div>
	</div>
</template>

<script>
import YoutubeEmbedLite from '@/components/funnels/pagebuilder/parts/YoutubeEmbedLite.vue';
import NodeAction from '@/components/funnels/pagebuilder/nodes/NodeAction.vue';
import {
	getYoutubeId,
	getNodeStyle,
	// eslint-disable-next-line
} from '@/lib/helper';

export default {
	name: 'NodeVideo',
	props: ['node', 'onPreview', 'previewDevice'],
	components: {
		NodeAction,
		YoutubeEmbedLite,
	},
	computed: {
		videoUrl() {
			let url = 'https://www.youtube.com/embed/oSf6cgYrjfM';
			if (this.node && this.node.options && this.node.options.src !== '') {
				const link = this.node.options.src;
				const youtubeId = getYoutubeId(link);
				url = `https://www.youtube.com/embed/${youtubeId}`;
			}
			return url;
		},
		ratio() {
			return this.node?.options?.ratio ?? '16by9';
		},
		responsiveClass() {
			return `embed-responsive-${this.ratio}`;
		},

		videoId() {
			let id = 'oSf6cgYrjfM';
			if (this.node && this.node.options && this.node.options.src !== '') {
				const link = this.node.options.src;
				id = getYoutubeId(link);
			}
			return id;
		},
		videoParams() {
			// parameters
			const autoplay = this.node.options.autoplay ? 1 : 0;
			const mute = this.node.options.mute ? 1 : 0;
			const loop = this.node.options.loop ? 1 : 0;
			const controls = this.node.options.player_controls ? 1 : 0;
			return {
				autoplay,
				mute,
				loop,
				controls,
			};
		},
	},
	methods: {
		getStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'padding',
				'box-shadow',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},
		getWrapperStyle({ options }) {
			const device = this.previewDevice;
			const styles = [
				'margin',
			];
			const style = getNodeStyle(options, styles, device);
			return style;
		},
		onNodeClick(node) {
			this.handleAction('edit', node);
		},
		handleAction(type, node) {
			this.$bus.$emit('action-element', type, node);
		},
	},
};
</script>

<style scoped></style>
